import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { defaultFormShape, imgBas64 } from "../Utils/constants";
import { formatNumber } from "../Utils/utils";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const generatePdfSimulateAS = (data) => {
  const years = data.datosSimulacion.periodo;
  const dateInit = moment(data.fechaCreacionAS).format("DD/MM/YYYY");
  const dateExpiration = moment(dateInit, "DD/MM/YYYY")
    .add("days", 8)
    .format("DD/MM/YYYY");
  const dateEnd = moment(dateInit, "DD/MM/YYYY")
    .add("years", years)
    .format("DD/MM/YYYY");
  const birthDate = data.datosCliente.nacimiento;
  const age = moment().diff(moment(birthDate, "DD/MM/YYYY"), "years");
  const toppings = data.cobertura;
  let rescue = data.rescate.map((i) => {
    let result = formatNumber.new(parseFloat(i.amount).toFixed(2));
    return [i.years, result];
  });
  let rescueRate = data.rescate.map((i) => {
    return [i.years, i.rate < 0 ? "(*)" : `${i.rate}%`];
  });

  if (
    rescue[rescue.length - 1] &&
    Number(data.datosSimulacion.periodo) !== defaultFormShape.period6months
  ) {
    rescue.splice(
      rescue.findIndex((res) => res[0] === defaultFormShape.period6months),
      1
    );
    rescueRate.splice(
      rescueRate.findIndex((res) => res[0] === defaultFormShape.period6months),
      1
    );
  }

  let rateWhenZeroYearNegative = "";
  const isZeroYearNegative = () => {
    const tmp = data.rescate.filter((i) => parseFloat(i.rate) < 0);
    if (tmp.length > 0) {
      rateWhenZeroYearNegative = tmp[0].rate * -1;
      return true;
    }
    return false;
  };

  const coverages = {
    "002": "Fallecimiento",
    "001": "Sobrevivencia",
    "004": "Indemnización adicional por fallecimiento accidental",
    "003": "Indemnización Oncológica",
  };

  let arrCoverage = [
    [
      { text: "Cobertura", fontSize: 10, color: "#545868" },
      { text: "Moneda", fontSize: 10, color: "#545868" },
      { text: "Suma Asegurada", fontSize: 10, color: "#545868" },
    ],
  ];

  for (const [id, name] of Object.entries(coverages)) {
    const item = toppings.find((el) => el.idTopping === id);
    if (item) {
      const amount = item.price || 0;
      arrCoverage.push([name, data.datosSimulacion.moneda.iso, amount]);
    }
  }

  const summary = {
    "001": "Por sobrevivencia",
    "003": "Por diagnóstico de cáncer",
    "004": "Por fallecimiento accidental",
    "002": "Por fallecimiento natural",
  };

  let arrSummary = [];
  for (const [id, name] of Object.entries(summary)) {
    const item = toppings.find((el) => el.idTopping === id);
    if (item) {
      if (id === "001") {
        arrSummary.push([
          {
            text: "En caso de sobrevivencia al periódo contratado, Ud. recibirá:",
            fontSize: 10,
            color: "#545868",
          },
          "",
          "",
        ]);
      } else if (id === "003") {
        arrSummary.push([
          {
            text: "En caso le detecten cáncer, Ud. recibirá:",
            fontSize: 10,
            color: "#545868",
          },
          "",
          "",
        ]);
      } else if (id === "004") {
        arrSummary.push([
          {
            text: "En caso Ud. faltara, sus beneficiarios recibirán:",
            fontSize: 10,
            color: "#545868",
          },
          "",
          "",
        ]);
      }
      const amount = item.price || 0;
      arrSummary.push([
        { text: name, margin: [10, 0, 0, 0] },
        data.datosSimulacion.moneda.iso,
        amount,
      ]);
    }
  }

  const header = {
    margin: 8,
    background: "blue",
    columns: [
      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                image: imgBas64.logo,
                width: 60,
                margin: [15, 0, 0, 0],
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
  };

  var docDefinition = {
    header,
    content: [
      {
        text: [
          {
            text: "Documento de simulación de ",
            fontSize: 18,
            color: "#545868;",
          },
          { text: "Ahorro Seguro", fontSize: 18, color: "#f0353b" },
        ],
        margin: [0, 20, 0, 5],
      },
      {
        text: `Vigencia del ${dateInit} hasta ${dateExpiration}`,
        color: "#545868;",
        fontSize: 10,
        margin: [0, 0, 0, 5],
      },
      {
        style: "tableTitle",
        table: {
          widths: [70, 100, 20, 40, 190],
          body: [
            ["Nº Cotización:", "-", "", "Asesor:", data.asesor],
            ["Nº Simulación:", data.numSimulacion, "", "Código:", "-"],
          ],
        },
        layout: {
          hLineWidth: function hLineWidth(i) {
            return 0;
          },
          vLineWidth: function vLineWidth(i) {
            return 0;
          },
          paddingLeft: function (i, node) {
            return 0;
          },
          paddingRight: function (i, node) {
            return 0;
          },
          paddingTop: function (i, node) {
            return 5;
          },
          paddingBottom: function (i, node) {
            return 5;
          },
        },
      },
      {
        text: "Datos del asegurado titular",
        color: "#545868;",
        fontSize: 14,
        margin: [0, 10, 0, 5],
      },
      {
        canvas: [
          {
            type: "rect",
            x: 0,
            y: 0,
            w: 520,
            h: 120,
            r: 5,
            lineColor: "#D4D5E8",
          },
        ],
      },
      {
        style: "tableContent",
        table: {
          body: [
            ["Nombre:", data.datosCliente.nombres.toUpperCase()],
            [
              "Doc.Identidad:",
              `${data.datosCliente.tipoDoc.nombre} ${data.datosCliente.documento}`,
            ],
            ["Edad:", age],
            ["Fecha Nacimiento:", birthDate],
            ["Correo:", data.datosCliente.correo || ""],
            ["Número de contacto:", data.datosCliente.celular || ""],
          ],
        },
        layout: "headerLineOnly",
        absolutePosition: { x: 60, y: 210 },
      },
      {
        text: "Datos de la cotización",
        color: "#545868;",
        fontSize: 14,
        margin: [0, 25, 0, 5],
      },
      {
        canvas: [
          {
            type: "rect",
            x: 0,
            y: 0,
            w: 520,
            h: 160 + 20 * toppings.length,
            r: 5,
            lineColor: "#D4D5E8",
          },
        ],
        absolutePosition: { x: 40, y: 355 },
      },
      {
        text: "Datos de inversión",
        color: "#545868;",
        fontSize: 12,
        margin: [10, 10, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [70, 80, 50, 100, 70],
          body: [
            [
              "Prima:",
              data.datosSimulacion.prima,
              "",
              "Moneda:",
              data.datosSimulacion.moneda.iso,
            ],
            [
              "Plazo:",
              Number(data.datosSimulacion.periodo) ===
              defaultFormShape.period6months
                ? "6 meses"
                : `${data.datosSimulacion.periodo} año${
                    Number(data.datosSimulacion.periodo) > 1 ? "s" : ""
                  }`,
              "",
              "Vencimiento Póliza:",
              dateEnd,
            ],
            ["TREA:", `${data.datosSimulacion.tasa}%`, "", "", ""],
          ],
        },
        layout: {
          hLineWidth: function hLineWidth(i) {
            return 0;
          },
          vLineWidth: function vLineWidth(i) {
            return 0;
          },
          paddingLeft: function (i, node) {
            return 0;
          },
          paddingRight: function (i, node) {
            return 0;
          },
          paddingTop: function (i, node) {
            return 3;
          },
          paddingBottom: function (i, node) {
            return 3;
          },
        },
        margin: [20, 10, 0, 5],
      },
      {
        text: "Datos del seguro",
        color: "#545868;",
        fontSize: 12,
        margin: [10, 15, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [250, 50, 90, 100],
          body: arrCoverage,
        },

        layout: {
          hLineWidth: function hLineWidth(i) {
            return 0;
          },
          vLineWidth: function vLineWidth(i) {
            return 0;
          },
          paddingLeft: function (i, node) {
            return 0;
          },
          paddingRight: function (i, node) {
            return 0;
          },
          paddingTop: function (i, node) {
            return 3;
          },
          paddingBottom: function (i, node) {
            return 3;
          },
        },
        margin: [20, 5, 0, 5],
      },
      {
        text: `RIMAC deja expresa constancia que ninguno de sus Asesores de Ventas están autorizados a recibir suma alguna de dinero ya sea por concepto de primas, comisiones, gastos, o cualquier otro concepto. RIMAC no asume ningiuna responsabilidad por cualquier pago, ya sea en efectivo o bajo cualquier otra modalidad que sea entregado a sus Asesores de Ventas.`,
        color: "#545868;",
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 30, 0, 0],
      },
      {
        text: `La aceptación de los términos de la presente propuesta, es requisito esencial para que el potencial contratante acceda a la posibilidad de suscribir la Solicitud de Seguro. En caso que, luego de suscrita la Solicitud de Seguro, el potencial contratante no cumpla con los requisitos de asegurabilidad establecidos para el presente producto, este documento quedará sin efecto alguno y no olbiga a RIMAC. La emisión de la presenta propuesta no es señal de aceptación del riesgo por parte de RIMAC SEGUROS. La aceptación del riesgo se evidencia con la emisión de la Póliza de Seguro respectiva.`,
        color: "#545868;",
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 10, 0, 5],
        pageBreak: "after",
      },
      {
        text: "Resumen integral de protección",
        color: "#545868;",
        fontSize: 14,
        margin: [0, 20, 0, 5],
      },
      {
        canvas: [
          {
            type: "rect",
            x: 0,
            y: 0,
            w: 520,
            h: 20 + 40 * toppings.length,
            r: 5,
            lineColor: "#D4D5E8",
          },
        ],
        absolutePosition: { x: 40, y: 85 },
      },
      {
        style: "tableContent",
        table: {
          widths: [320, 50, 90, 100],
          body: arrSummary,
        },

        layout: {
          hLineWidth: function hLineWidth(i) {
            return 0;
          },
          vLineWidth: function vLineWidth(i) {
            return 0;
          },
          paddingLeft: function (i, node) {
            return 0;
          },
          paddingRight: function (i, node) {
            return 0;
          },
          paddingTop: function (i, node) {
            return 4;
          },
          paddingBottom: function (i, node) {
            return 4;
          },
        },
        margin: [30, 20, 0, 5],
      },
      {
        text: "El pago de la prima se realizará mediante transferencia bancaria o depósito en las cuentas de Rimac. Toda comisión por transferencia y/o cualquier otro gasto que demande la transferencia de los fondos a RIMAC, por concepto de prima, serán de cuenta y cargo del CONTRATANTE.",
        color: "#545868;",
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 30, 0, 0],
      },
      {
        text: "Los asegurados mayores de 70 años o quienes marcaron Sí en la Declaración Personal de Salud sólo tendrán las coberturas de fallecimiento y sobrevivencia. La Suma Asegurada de Fallecimiento corresponderá a la Prima Única pagada más los intereses ganados y liquidados a la fecha en que se haya producido el fallecimiento del Asegurado.",
        color: "#545868;",
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 10, 0, 0],
      },
      {
        text: "Cuadro de Valores",
        color: "#545868;",
        fontSize: 14,
        margin: [0, 10, 0, 5],
      },
      {
        canvas: [
          {
            type: "rect",
            x: 0,
            y: 0,
            w: 520,
            h: 410,
            r: 5,
            lineColor: "#D4D5E8",
          },
        ],
        absolutePosition: { x: 40, y: 245 + 40 * toppings.length },
      },
      {
        text: "Valores de Rescate",
        color: "#545868;",
        fontSize: 12,
        margin: [20, 20, 0, 5],
      },
      {
        text: "Valores de Rescate por año cumplido de vigencia:",
        color: "#545868;",
        fontSize: 10,
        margin: [20, 5, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [50, 200],
          body: [
            [
              { text: "Año", fontSize: 10, color: "#545868" },
              { text: "Rescate", fontSize: 10, color: "#545868" },
            ],
            ...rescue,
          ],
        },
        layout: {
          hLineWidth: function hLineWidth(i) {
            return 0;
          },
          vLineWidth: function vLineWidth(i) {
            return 0;
          },
          paddingLeft: function (i, node) {
            return 0;
          },
          paddingRight: function (i, node) {
            return 0;
          },
          paddingTop: function (i, node) {
            return 3;
          },
          paddingBottom: function (i, node) {
            return 3;
          },
        },
        margin: [45, 10, 0, 5],
      },
      {
        text: "Tabla de Tasas de Rentabilidad Efectiva Anual",
        color: "#545868;",
        fontSize: 12,
        margin: [20, 20, 0, 5],
      },
      {
        text: "Aplicable para el cálculo del valor de rescate solicitado antes del fin de vigencia de la póliza.",
        color: "#545868;",
        fontSize: 10,
        margin: [20, 5, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [50, 200],
          body: [
            [
              { text: "Año", fontSize: 10, color: "#545868" },
              { text: "TREA", fontSize: 10, color: "#545868" },
            ],
            ...rescueRate,
          ],
        },
        layout: {
          hLineWidth: function hLineWidth(i) {
            return 0;
          },
          vLineWidth: function vLineWidth(i) {
            return 0;
          },
          paddingLeft: function (i, node) {
            return 0;
          },
          paddingRight: function (i, node) {
            return 0;
          },
          paddingTop: function (i, node) {
            return 3;
          },
          paddingBottom: function (i, node) {
            return 3;
          },
        },
        margin: [45, 10, 0, 5],
      },
      {
        text: isZeroYearNegative()
          ? `(*) Todo rescate que se solicite antes de haber cumplido el primer año desde la contratación de la póliza, tendrá un descuento por concepto de costo de gasto de administración del ${rateWhenZeroYearNegative}% sobre el capital invertido.`
          : "",
        color: "#545868;",
        fontSize: 10,
        margin: [20, 5, 20, 5],
        lineHeight: 1.2,
      },
    ],
    styles: {
      pdfHeader: {
        background: "#ef3340",
      },
      tableTitle: {
        margin: [0, 5, 0, 5],
        fontSize: 10,
      },
      tableContent: {
        fontSize: 10,
      },
    },
  };

  pdfMake.createPdf(docDefinition).open();
};
